export default __webpack_public_path__ + "static/media/qr-templated-gas91.4b26b369.png";